import { render, staticRenderFns } from "./formDropdownLabelInput.vue?vue&type=template&id=7d25854f&scoped=true&"
import script from "./formDropdownLabelInput.vue?vue&type=script&lang=js&"
export * from "./formDropdownLabelInput.vue?vue&type=script&lang=js&"
import style0 from "./formDropdownLabelInput.vue?vue&type=style&index=0&id=7d25854f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d25854f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d25854f')) {
      api.createRecord('7d25854f', component.options)
    } else {
      api.reload('7d25854f', component.options)
    }
    module.hot.accept("./formDropdownLabelInput.vue?vue&type=template&id=7d25854f&scoped=true&", function () {
      api.rerender('7d25854f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/formDropdownLabelInput.vue"
export default component.exports